export default __webpack_public_path__ + "static/media/heartbreak_icon.c888b6e9.svg";